import { createSlice } from '@reduxjs/toolkit';
import { RESET_ALL_REDUCERS } from 'actions';

const initialState = {
    reAuthenticateSessionID: undefined,
    reauthenticateSessionStatus: undefined,
    sessionStatus: undefined,
    isDeviceInfoSent: undefined,
    codeResentAt: null,
};

const reauthenticateSlice = createSlice({
    name: 'reauthenticate',
    initialState,
    reducers: {
        setSessionId: (state, action) => {
            state.reAuthenticateSessionID = action.payload;
        },
        resetSessionId: (state) => {
            state.reAuthenticateSessionID = undefined;
        },
        setSessionStatus: (state, action) => {
            state.reauthenticateSessionStatus = action.payload;
        },
        updateSelfieCheck: (state, action) => {
            state.reauthenticateSessionStatus = {
                ...(state.reauthenticateSessionStatus ?? {}),
                selfieVerification: { ...action.payload },
            };
        },
        setSessionUpdateStatus: (state, action) => {
            state.sessionStatus = action.payload;
        },
        updateAdditionalVerification: (state, action) => {
            state.reauthenticateSessionStatus = {
                ...(state.reauthenticateSessionStatus ?? {}),
                additionalVerification: { ...action.payload },
            };
        },
        setDeviceInfoSent: (state) => {
            state.isDeviceInfoSent = true;
        },
        setCodeResentAt: (state, action) => {
            state.codeResentAt = action.payload;
        },
    },
    // RESET_ALL_REDUCERS is the shared app-wide reset (dispatched on token/session
    // change; every slice — incl. onboarding's sessionSlice — listens to it). Not a
    // reauth-specific constant.
    extraReducers: (builder) => {
        builder.addCase(RESET_ALL_REDUCERS, () => ({ ...initialState }));
    },
});

export const {
    setSessionId,
    resetSessionId,
    setSessionStatus,
    updateSelfieCheck,
    setSessionUpdateStatus,
    updateAdditionalVerification,
    setDeviceInfoSent,
    setCodeResentAt,
} = reauthenticateSlice.actions;

export default reauthenticateSlice.reducer;
